
































































































import {google} from 'google-maps';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import {ICoord, ISearchMapResult, HTMLVueGoogleMaps} from '@/models/IMap.ts';
import {IHub, initialHub, isInitialHub} from '@/models/StoreModels.ts';
import {CROSS_TOWN_ROUTES} from "@/constants/routes";

import Markers from './Markers/Markers.vue';
import {barcelonaCoordinates, mapStyles} from "@/constants/maps";
import {namespace, Getter} from "vuex-class";

const hubsModule = namespace("hubs");
const shipmentStore = namespace("shipment");

@Component({
  name: 'Maps',
  components: {
    Markers,
  },
})
export default class Maps extends Vue {
  public $refs!: {
    mapRef: HTMLVueGoogleMaps,
  };

  @Getter('getDefaultHub')
  private getDefaultHub!: IHub;

  @hubsModule.Getter("getHubById")
  private getHubById!: (id: number) => IHub;

  @hubsModule.Getter("existsOnlyOneHub")
  private existsOnlyOneHub!: boolean;

  @shipmentStore.Getter("getFromHubId")
  private getFromHubId!: number;

  @Prop({default: []})
  private hubList!: IHub[];

  @Prop({ default: () => () => null })
  private clickNextButton!: (hub: IHub) => void;

  @Prop({ default: null })
  private clickExitButton!: () => void | null;

  @Prop({ default: () => () => null })
  private onMarkerClick!: (hub: IHub) => void;

  @Prop({default: true})
  private showConfirmButton!: boolean;

  @Prop({default: true})
  private showBackButton!: boolean;

  @Prop({default: true})
  private showAllButtons!: boolean;

  @Prop({default: true})
  private showSearch!: boolean;


  @Prop({default: initialHub})
  private selectedOnOpen!: IHub;



  private zoom: number = 15;
  private gmaps?: google.maps.Map;

  private selectedHub: IHub = initialHub();
  private mapsCoordinates: ICoord = barcelonaCoordinates;

  private get shipmentFromHub(): IHub {
    return this.getHubById(this.getFromHubId);
  }

  @Watch('hubList')
  private hubListWatcher() {
    if (this.hubList.length === 1 ) {
      this.selectedHub = this.hubList[0];
    } else if (!isInitialHub(this.selectedOnOpen)) {
      this.selectedHub = this.selectedOnOpen;
    } else if (!isInitialHub(this.shipmentFromHub) && this.$route.name === CROSS_TOWN_ROUTES.START) {
      this.selectedHub = this.shipmentFromHub;
    } else if (!isInitialHub(this.getDefaultHub)) {
      this.selectedHub = this.getDefaultHub;
    }
  }

  get mapCentroid(): ICoord {
    const res: ICoord = {
      lat: 0,
      lng: 0,
    };

    this.hubList.map((el: IHub) => {
      res.lat = res.lat + el.geo_lat;
      res.lng = res.lng + el.geo_long;
    });

    res.lat = res.lat / this.hubList.length;
    res.lng = res.lng / this.hubList.length;

    return res;
  }

  private mounted() {
    this.mapsCoordinates = this.mapCentroid;
    this.hubListWatcher();
    this.onMarkerClick(this.selectedHub);

    this.$refs.mapRef.$mapPromise.then((map: google.maps.Map) => {
      this.gmaps = map;
      this.gmaps.setOptions(mapStyles);
      this.calculateBounds();
    });
  }


  private calculateBounds() {
    this.getMapBounds()
        .then(bounds => {
          for (const hub of this.hubList) {
            // @ts-ignore
            bounds.extend({ lat: hub.geo_lat, lng: hub.geo_long });
          }

          // @ts-ignore
          this.gmaps.fitBounds(bounds);
        });
  }

  /**
   * gets the map bounds when the map is ready.
   *
   * The system doesn't return the bounds even if the map is already ready, and we cannot cancel events from
   * google maps api with our plugin, so I decided to add a Promise that checks every 100 milliseconds if we can
   * get the bounds already. If that is the case, we will stop checking and resolve the promise with the bounds.
   * @private
   */
  private getMapBounds(): Promise<any> {
    return new Promise((resolve) => {
      // @ts-ignore
      let bounds = this.gmaps.getBounds();
      let counter = 0;

      const myTimeOut = () => setTimeout(() => {
        if (!bounds) {
          counter = counter + 1;
          // @ts-ignore
          bounds = this.gmaps.getBounds();
          myTimeOut();
        } else {
          resolve(bounds);
        }
      }, 500);

      myTimeOut();

    });
  }

  get isHubSelected() {
    return this.selectedHub && this.selectedHub.id > 0;
  }

  get selectedAddress() {
    if (this.isHubSelected) {
      return this.selectedHub.address;
    }

    return this.$t('maps.altText');
  }

  private confirmHub() {
    if (this.isHubSelected) {
      this.clickNextButton(this.selectedHub);
    }
  }

  private markerClick(hub: IHub) {
    this.selectedHub = hub;
    this.onMarkerClick(hub);
  }

  private focusInCoordinates(coordinates: ICoord, zoom: number = 15) {
    this.zoom = zoom;
    this.mapsCoordinates = coordinates;

    if (this.gmaps) {
      this.gmaps.panTo(coordinates);
      this.gmaps.setZoom(zoom);
    }
  }

  private centerMapInUser() {
    navigator.geolocation.getCurrentPosition(
      this.successUserCoordinates, // if we succeed in getting user coordinates, we center in them
      this.errorUserCoordinates);   // if we had an error, we will center in the hubs centroid

  }

  private centerInHub() {
    let hubPoint: ICoord = this.mapCentroid;
    if (this.isHubSelected) {
      hubPoint = {
        lat: this.selectedHub.geo_lat,
        lng: this.selectedHub.geo_long,
      };
    }

    this.focusInCoordinates(hubPoint);
  }

  private successUserCoordinates(position: Position) {
    this.focusInCoordinates({
      lng: position.coords.longitude,
      lat: position.coords.latitude,
    });
  }

  private errorUserCoordinates() {
    this.focusInCoordinates(this.mapCentroid);
  }

  private gmapAutocompleteSetPlace(data: ISearchMapResult) {
    this.focusInCoordinates({
      lat: data.geometry.location.lat(),
      lng: data.geometry.location.lng(),
    });
  }

  private back() {
    this.clickExitButton ? this.clickExitButton() :
                           this.$uiBus.emit("dropup:close");
  }
}
